<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <el-image v-if="swiperList && swiperList.length!=0"
              style="min-width: 1200px; height: 463px;"
              :src="swiperList[0].resourceUrl"></el-image>
    <!-- <video style="width:100%; height: 463px;object-fit: fill"
           class="video"
           :loop="true"
           :controls="false"
           :autoplay="true"
           :src="swiperList[0].resourceUrl"></video> -->
    <!-- 私董会 -->
    <div class="privateBoard_box"
         :style="{'backgroundImage':'url(' + $imgUrl + '/Bosscircle/BJ.jpg)','backgroundSize':'100% 100%'}">
      <div class="currency_box">
        <curTitle color="#fff"
                  :data="{title:'私董会',content:'建立一个有理念、有想法、能同频、对商业有认知零售企业家圈子'}"></curTitle>
      </div>
      <div class="currency_boxs"
           style="margin-top:40px">
        <privateBoard></privateBoard>
      </div>
    </div>
    <!-- 私董会  | 精彩瞬间  -->
    <div class="moment_box">
      <div class="currency_box">
        <curTitle color="#333"
                  :data="{title:'私董会 | 精彩瞬间',content:'共建老板圈子，资源共享平台'}"></curTitle>
      </div>
      <div style="margin: 40px 0 0 0;">
        <moment v-if="momentShow"
                :momentList="momentList"></moment>
      </div>
    </div>
    <!--  -->
    <div class="activity_box"
         v-if="activityList.length!=0"
         style="background-color:#F5F5F5">
      <div class="currency_box">
        <curTitle color="#333"
                  :data="{title:'私董会 | 活动安排',content:'共建老板圈子，资源共享平台'}"></curTitle>
      </div>
      <div style="margin: 40px 0 40px 0;">
        <activity-box :list="activityList"></activity-box>
      </div>
    </div>
    <!-- 私董会介绍 -->
    <div class="activity_box"
         style="padding-top:40px;background-color: #fff;padding-bottom: 40px;">
      <div class="currency_box"
           style="margin-bottom:30px">
        <curTitle color="#333"
                  :data="{title:'私董会简介',content:'未来新业态和新项目资本联投'}"></curTitle>
      </div>
      <div class="currency_box"
           v-for="(item,index) in contentList"
           :key="index">
        <el-image v-if="item.resourceType == 1"
                  style="width:100%;cursor: pointer;"
                  @click="$Public.link(item)"
                  :src="item.resourceUrl"></el-image>
        <video v-if="item.resourceType == 2"
               class="video"
               muted
               style="width:100%;height:100%"
               :controls="true"
               :autoplay="false"
               :poster="item.coverUrl"
               :src="item.resourceUrl"></video>
        <!-- muted -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  resourceList, courseActivityList
} from '@/api/api.js'
import curTitle from '@/components/home/cur_title.vue'
import privateBoard from './components/privateBoard.vue'
import moment from './components/moment.vue'
import activityBox from './components/activity.vue'
export default {
  components: { curTitle, privateBoard, moment, activityBox },
  data () {
    return {
      activityList: [],
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      swiperList: [],
      data: {
        showIndex: 5,
        pageNumber: 1,
        pageSize: 100
      },
      contentList: [],
      momentList: [],
      momentShow: false,
      activityData: {
        activityType: 1,
        pageNumber: 1,
        pageSize: 100
      }
    }
  },
  created () {
    this.getresourceList(5)
    this.getresourceList(12)
    this.getresourceList(13)
    this.getcourseActivityList()
  },
  methods: {
    async getcourseActivityList () {
      const res = await courseActivityList(this.activityData)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.activityList = res.data.records;
    },
    async getresourceList (type) {  //获取首页资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      if (type == 5) {
        this.swiperList = res.data;
      } else if (type == 12) {
        this.momentList = this.split_array(res.data, 8)
        this.momentShow = true;
      } else if (type == 13) {
        this.contentList = res.data;
      }
    },
    split_array (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      // console.log(newArray)
      return newArray;
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  .activity_box {
    min-width: 1200px;
    background-color: #f5f5f5;
  }
  .privateBoard_box {
    min-width: 1200px;
    height: 880px;
    background-color: #000;
  }
  .moment_box {
    min-width: 1200px;
    background-color: #fff;
    padding-bottom: 80px;
  }
}
</style>
